import {createGlobalStyle} from 'styled-components';
import {normalize} from 'styled-normalize';
import {getColorFromTheme} from '../ui-utils';
import {reset} from './reset';

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  ${reset}

  :root {
    --beam-canvas: ${({theme}) => theme.colors.backgroundLight};
    --beam-surface: ${({theme}) => theme.colors.white};
    --beam-surface-muted: ${({theme}) => theme.colors.backgroundDark};
    --beam-text-primary: ${({theme}) => theme.colors.blackTwo};
    --beam-text-secondary: ${({theme}) => theme.colors.textBody};
    --beam-text-muted: ${({theme}) => theme.colors.textMuted};
    --beam-border-light: ${({theme}) => theme.colors.borderLight};
    --beam-border-dark: ${({theme}) => theme.colors.borderDark};
    --beam-purple: ${({theme}) => theme.colors.purple300};
    --beam-purple-hover: ${({theme}) => theme.colors.warmBlue};
    --beam-purple-subtle: ${({theme}) => theme.colors.purple100};
    --beam-on-brand: ${({theme}) => theme.colors.alwaysWhite};
    --beam-focus: ${({theme}) => theme.colors.purple200};
    --beam-green-subtle: ${({theme}) => theme.colors.green100};
    --beam-blue-subtle: ${({theme}) => theme.colors.blue100};
    --beam-orange-subtle: ${({theme}) => theme.colors.orange100};
    --beam-red-subtle: ${({theme}) => theme.colors.red100};
    --beam-red: ${({theme}) => theme.colors.red400};
    --beam-red-strong: ${({theme}) => theme.colors.red500};
    --beam-green: ${({theme}) => theme.colors.green300};
    --beam-green-strong: ${({theme}) => theme.colors.green500};
    --beam-orange: ${({theme}) => theme.colors.orange300};
    --beam-orange-strong: ${({theme}) => theme.colors.orange400};
  }

  body {
    font-family: ${(props) => props.theme.fontFamily};
    margin: 0;
    padding: 0;
    background: ${({theme}) => theme.colors.backgroundLight};
    color: ${({theme}) => theme.colors.blackTwo};
    -webkit-font-smoothing: antialiased;
    text-rendering: geometricPrecision;
    height: 100%;
    transition: background-color 160ms ease, color 160ms ease;
  }

  html {
    height: 100%;
  }

  * {
    box-sizing: border-box;
  }

  a:focus:not(.focus-visible),
  *:focus {
    outline: none;
    box-shadow: none;
  }

  a.focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${getColorFromTheme('purple200')};
  }

 
  * {
    scrollbar-color: ${({theme}) => theme.colors.borderDark}
      ${({theme}) => theme.colors.backgroundDark};
  }

  *::-webkit-scrollbar-track {
    background: ${({theme}) => theme.colors.backgroundDark};
    border: 0.8em solid rgba(0, 0, 0, 0);
    background-clip: padding-box;

    -webkit-border-radius: 1.5em;

    border-radius: 100px;
  }

  *::-webkit-scrollbar-thumb {
    height: 10em;
    border: 0.8em solid rgba(0, 0, 0, 0);
    background: ${({theme}) => theme.colors.borderDark};
    border-radius: 10px;
    background-clip: padding-box;
    -webkit-border-radius: 1.5em;

    -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
  }

  *::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  *::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
